import { ExecutiveSummary } from './executive-summary.model';
import { EntityType } from './entity-id-details.model';

export class EntityRelation {
  id: number;
  subjectId: number;
  entityId: number;
  clientId: number;
  detailId: number;
  role: number;
  ubo: boolean;
  pep: boolean;
  name: string;
  routeName: string;
  image: string;
  commentVO: ExecutiveSummary;
  entityType: EntityType;
  meta: Map<string, string> = new Map();
}



// WEBPACK FOOTER //
// ./src/app/shared/models/entity-relation.model.ts